'use client';

import { Pagination } from 'antd';
import type { PaginationProps } from 'antd';
import { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  mergeEvimoPaginationProps,
  type EvimoPaginationLiveState,
} from '~/app/components/common/EvimoTable/evimoTablePagination';

type EvimoPaginationProps = PaginationProps;

/** Standalone pagination (same labels/options as {@link EvimoTable}). */
export function EvimoPagination(props: EvimoPaginationProps) {
  const { t, i18n } = useTranslation('common');
  const paginationLiveState = useRef<EvimoPaginationLiveState>({
    pageSize: 10,
    current: 1,
  });

  const merged = useMemo(
    () => mergeEvimoPaginationProps(props, t, paginationLiveState),
    [props, t, i18n.language],
  );

  return <Pagination className="evimo-table-pagination" {...merged} />;
}
